import { PanelLeftOpen, SquarePen } from "lucide-react";

/**
 * Yuqori qator — faqat chap panel ko'rinmaganda (telefon yoki yig'ilgan):
 * panelni ochish, brend va yangi suhbat. Panel ochiq bo'lsa hammasi panelda bor.
 */
export function Header({ onOpenPanel, onReset, hasMessages }) {
  return (
    <header className="relative z-30 flex shrink-0 items-center justify-between gap-3 border-b border-sky-800/30 bg-[#051a38]/90 px-3 py-2 backdrop-blur-md sm:px-5">
      <div className="flex items-center gap-2">
        <button
          onClick={onOpenPanel}
          title="Panelni ochish"
          className="rounded-lg p-2 text-slate-300 transition-colors hover:bg-white/5 hover:text-white"
        >
          <PanelLeftOpen className="h-5 w-5" />
        </button>
        <button
          onClick={onReset}
          title="Yangi suhbat"
          className="flex cursor-pointer select-none items-center gap-2 rounded-lg transition-opacity hover:opacity-80"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-sky-500/40 bg-sky-950/70 p-1">
            <img src="/logo.png" alt="" className="h-full w-full object-contain" />
          </div>
          <span className="text-sm font-bold tracking-wide text-white">AIExpert</span>
        </button>
      </div>

      {hasMessages && (
        <button
          onClick={onReset}
          title="Yangi suhbat"
          className="rounded-lg p-2 text-slate-300 transition-colors hover:bg-white/5 hover:text-white"
        >
          <SquarePen className="h-5 w-5" />
        </button>
      )}
    </header>
  );
}
